import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ClearIcon from '@mui/icons-material/Clear';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import TopicIcon from '@mui/icons-material/Topic';
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Slide, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeStorageModal } from '../../DataStore/modalSlice';
import { useCreateArtifactStoragePathMutation } from '../../Services/artifactStorageApi';
import { color } from '../../Styles/Color';
import { getTrimmedData } from '../../Utils/trimmer';
import CustomButton from '../UiComponents/CustomButton';
import Loader from '../UiComponents/Loader';
import SecondaryButton from '../UiComponents/SecondaryButton';
import ChooseStorageType from './ChooseStorageType';
import StorageDataForm from './StorageDataForm';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AddPathModal = () => {
  const [isActive, setIsActive] = useState("");
  const [storageType, setStorageType] = useState("");
  const initialFormState = Object.freeze({
    name: "",
    path: "",
    credentials: {}
  })

  const [formValues, setFormValues] = useState(initialFormState)

  const [handleSubmit, { isLoading, isSuccess }] = useCreateArtifactStoragePathMutation();
  const { isStorageModalOpen } = useSelector((store) => store.modal)

  const dispatch = useDispatch();

  useEffect(() => {
    if (isSuccess) handleClose()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess])

  const handleClose = () => {
    setIsActive("")
    setStorageType("")
    dispatch(closeStorageModal())
  }

  const handleNext = () => {
    setStorageType(isActive)
  }

  const handleAdd = () => {
    const config = getTrimmedData(formValues)
    handleSubmit(config);
  }

  const handleCancel = () => {
    setFormValues(initialFormState)
    setStorageType("")
    setIsActive("")
  }

  return (
    <Dialog
      maxWidth="xl"
      open={isStorageModalOpen}
      onClose={handleClose}
      PaperProps={{
        sx: {
          borderRadius: "12px",
          px: 2,
          py: 1,
          boxShadow: "0px 0px 4px 0px #00000014"
        }
      }}
      TransitionComponent={Transition}
      keepMounted
      slotProps={{
        backdrop: {
          sx: {
            background: "#E4E4E48A",
            backdropFilter: "blur(3px)",
          },
        }
      }}
    >
      <DialogTitle sx={{ p: 2 }}>
        <Stack justifyContent="space-between" direction="row">
          <Stack direction="row" gap={2} alignItems="center">
            <Stack
              padding={1}
              borderRadius="8px"
              bgcolor={color.primary}
              color={color.white}
            >
              <TopicIcon fontSize='20px' />
            </Stack>
            <Typography variant='h2' color={color.primary}>Add Artifact Storage</Typography>
          </Stack>
          {
            !storageType ?
              <IconButton onClick={handleClose}>
                <ClearIcon sx={{ fontSize: '24px', color: color.primary }} />
              </IconButton>
              :
              <Stack
                direction="row"
                gap={1}
                color={color.primary}
                alignItems="center"
                onClick={handleCancel}
                sx={{
                  "&:hover": {
                    cursor: "pointer"
                  }
                }}
              >
                <ArrowBackIcon fontSize='small' />
                <Typography>Go Back </Typography>
              </Stack>
          }
        </Stack>
      </DialogTitle>
      <DialogContent
        sx={{
          minHeight: "35vh",
          width: "45vw",
          // p: 2,
          // '&::-webkit-scrollbar': {
          //   display: 'none',
          // }
        }}
      >
        {
          isLoading ?
            <Stack height="50vh">
              <Loader />
            </Stack>
            :
            <>
              {
                storageType === "" ?
                  <ChooseStorageType isActive={isActive} setIsActive={setIsActive} /> :
                  <StorageDataForm
                    formValues={formValues}
                    setFormValues={setFormValues}
                    storageType={storageType}
                  />
              }
            </>
        }
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Stack direction="row" justifyContent="space-between" width="100%" alignItems="center">
          <Stack
            direction="row"
            gap={1}
            color={color.primary}
            alignItems="center"
            sx={{
              "&:hover": {
                cursor: "pointer"
              }
            }}
            onClick={() => window.open("https://docs.scalegen.ai", "_blank")}
          >
            <MenuBookIcon fontSize='small' />
            <Typography variant='body1'>
              Docs
            </Typography>
          </Stack>
          {
            !storageType ?
              <CustomButton
                onClick={handleNext}
                width="10%"
                disabled={!isActive}
              >
                Next
              </CustomButton>
              :
              <Stack direction="row" gap={1}>
                <SecondaryButton onClick={handleClose}>
                  Cancel
                </SecondaryButton>
                <CustomButton
                  onClick={handleAdd}
                  width="10%"
                >
                  Add
                </CustomButton>
              </Stack>
          }

        </Stack>
      </DialogActions>
    </Dialog>
  )
}

export default AddPathModal